<div
    bsModal
    #createOrEditModal="bs-modal"
    class="modal fade"
    tabindex="-1"
    role="dialog"
    aria-labelledby="createOrEditModal"
    aria-hidden="true"
    [config]="{ backdrop: 'static' }"
>
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <form #unitForm="ngForm" novalidate (ngSubmit)="save()" autocomplete="off">
                <div class="modal-header">
                    <h4 class="modal-title">
                        <span *ngIf="unit.id">{{ l('EditUnit') }}</span>

                        <span *ngIf="!unit.id">{{ l('CreateNewUnit') }}</span>
                    </h4>

                    <button
                        type="button"
                        class="btn-close"
                        (click)="close()"
                        aria-label="Close"
                        [disabled]="saving"
                    ></button>
                </div>
                <div class="modal-body">
                    <div class="my-3">
                        <label class="form-label" for="Unit_Name">{{ l('Name') }} *</label>
                        <input
                            type="text"
                            #Unit_Name="ngModel"
                            id="Unit_Name"
                            class="form-control"
                            [(ngModel)]="unit.name"
                            name="Name"
                            minlength="0"
                            maxlength="280"
                            required
                        />
                        <validation-messages [formCtrl]="Unit_Name"></validation-messages>
                    </div>

                    

                    <div class="my5">
                        <label class="form-label" for="Unit_NoOfUnits">{{ l('NoOfUnits') }}</label>
                        <input
                            type="number"
                            #Unit_NoOfUnits="ngModel"
                            id="Unit_NoOfUnits"
                            class="form-control"
                            [(ngModel)]="unit.noOfUnits"
                            name="NoOfUnits"
                        />
                        <validation-messages [formCtrl]="Unit_NoOfUnits"></validation-messages>
                    </div>
                    <br />
                    <label class="form-check form-check-custom form-check-solid">
                        <input
                            id="Unit_IsBaseUnit"
                            #Unit_IsBaseUnit="ngModel"
                            name="IsBaseUnit"
                            [(ngModel)]="unit.isBaseUnit"
                            type="checkbox"
                            class="form-check-input"
                        />
                        <span class="form-check-label">
                            {{ l('IsBaseUnit') }}
                        </span>
                    </label>
                    <validation-messages [formCtrl]="Unit_IsBaseUnit"></validation-messages>
                </div>
                <div class="modal-footer">
                    <button [disabled]="saving" type="button" class="btn btn-danger" (click)="close()">
                        {{ l('Cancel') }}
                    </button>
                    <button
                        type="submit"
                        class="btn btn-primary blue"
                        [disabled]="!unitForm.form.valid"
                        [buttonBusy]="saving"
                        [busyText]="l('SavingWithThreeDot')"
                    >
                        <i class="fa fa-save"></i>
                        <span>{{ l('Save') }}</span>
                    </button>
                </div>
            </form>
        </div>
    </div>
</div>
